import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { getImgAltText } from 'utils/alt-attribute-helper';

class Services extends Component
{
    render()
    {
        return (
            <div className="tw-flex tw-flex-wrap tw-mt-16 lg:tw-mt-24 lg:tw-justify-center">
                <Fade bottom>
                    <div className="tw-w-full lg:tw-w-1/3 tw-px-0 lg:tw-px-8 xl:tw-px-0 xl:tw-w-1/5 xl:tw-mx-8 tw-mb-12">
                        <img loading="lazy" src="/assets/icons/hotel.svg" alt={getImgAltText('Handpicked Collection')} className="tw-h-16 tw-mx-auto tw-mb-6" />
                        <h3 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6">Handpicked Collection</h3>
                        <p>We select, review and rate each property in our collection.</p>
                    </div>
                </Fade>
                <Fade bottom>
                    <div className="tw-w-full lg:tw-w-1/3 tw-px-0 lg:tw-px-8 xl:tw-px-0 xl:tw-w-1/5 xl:tw-mx-8 tw-mb-12">
                        <img loading="lazy" src="/assets/icons/service.svg" alt={getImgAltText('Handpicked Collection')} className="tw-h-16 tw-mx-auto tw-mb-6" />
                        <h3 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6">Personalized Service</h3>
                        <p>Our team can help create a trip that’s designed around you.</p>
                    </div>
                </Fade>
                <Fade bottom>
                    <div className="tw-w-full lg:tw-w-1/3 tw-px-0 lg:tw-px-8 xl:tw-px-0 xl:tw-w-1/5 xl:tw-mx-8 tw-mb-12">
                        <img loading="lazy" src="/assets/icons/drink.svg" alt={getImgAltText('Handpicked Collection')} className="tw-h-16 tw-mx-auto tw-mb-6" />
                        <h3 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6">Exclusive Perks & Offers</h3>
                        <p>Enjoy access to our special offers and unique benefits.</p>
                    </div>
                </Fade>
            </div>
        );
    }
}

Services.propTypes = {};

export default Services;
